import {Component, Object3D, RetainEmitter} from '@wonderlandengine/api';

export class WeaponPrefabs extends Component {
    static TypeName = 'weapon-prefabs';
    static instance: WeaponPrefabs;

    weaponPrefabs!: Object3D;
    onPrefabsLoaded = new RetainEmitter<[Object3D]>();

    init(): void {
        WeaponPrefabs.instance = this;
    }

    async start() {
        const s = await this.engine.loadPrefab('Weapons.bin');
        const r = this.engine.scene.instantiate(s);
        r.root.translateWorld([0, -100, 0]);
        this.weaponPrefabs = r.root;
        this.weaponPrefabs.parent = this.object;
        setTimeout(() => this.onPrefabsLoaded.notify(this.weaponPrefabs), 0);
    }
}
